import React, { useState, useEffect } from 'react';
import Select from 'react-select';

import {
  EventFields,
  PageviewFields,
  AbandonFields
} from './';

const Components = {
  eventsFields: EventFields,
  pageviewFields: PageviewFields,
  abandonFields: AbandonFields
}

export const Trigger = (props) => {
  const [ localData, setLocalData ] = useState({});
  const [ selectedFilter, setSelectedFilter ] = useState({});
  
  useEffect(() => {
    if ( !localData.trigger ) return;
    
    const { data, setData } = props.parentData;
    setData({...data, trigger: [localData.trigger]});
  }, [localData]);

  const handleFilterChange = e => {
    setSelectedFilter(e);
    setLocalData({...props.localData, trigger: {filter: e.value}});
  }

  const defineComponent = (parentProps) => {
    if ( !selectedFilter.value ) return;

    let Component = Components[selectedFilter.value + 'Fields'];
    if ( !Component ) return;

    return <Component localData={localData} setLocalData={setLocalData}/>;
  }

  return (
    <div className="block block__trigger">
      <div className="block__body">
        <p className="title">
          <i className="linearicons-mouse-left"></i> Gatilho
          <span className="title__addon">Obrigatório</span>
        </p>
        <div className="conditions__wrapper">
           <div className="form__group form__group--inline">
            <div className="titled__group">
              <p>Filtrar por:</p>
              <Select
                options={[
                  {label: "Abandono", value: "abandon"},
                  {label: "Eventos", value: "events"},
                  {label: "Visualização de página", value: "pageview"}
                ]}
                className="basic-select"
                classNamePrefix="select"
                placeholder="Selecione o gatilho"
                onChange={handleFilterChange}
              />
            </div>

            { defineComponent(props) }
          </div>
        </div>
      </div>
    </div>    
  )
}